import { render, staticRenderFns } from "./ClipDetails.vue?vue&type=template&id=b6e90b06"
import script from "./ClipDetails.vue?vue&type=script&lang=js"
export * from "./ClipDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports